import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';
// import logo from '../assets/vault-logo.png';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="notfound-wrapper">
      <div className="notfound-card">
        {/* <img src={logo} alt="Vaultize" className="notfound-logo" /> */}

        <h1 className="notfound-code">404</h1>
        <h2 className="notfound-title">Page not found</h2>

        <p className="notfound-text">
          The page you’re trying to access doesn’t exist or may have been moved.
        </p>

        <div className="notfound-actions">
          <button onClick={() => navigate('/')} className="primary-btn">
            Back to Dashboard
          </button>
          <button onClick={() => navigate(-1)} className="secondary-btn">
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
